module.exports = __webpack_public_path__ + "img/progressicowhite.5ac0ba18.png";